var React = require('react');

function ShareIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#f40"},[React.createElement("path",{"d":"M11.143 8.948v1.592h4.776v9.552H1.592V10.54h4.776V8.948H1.75A1.749 1.749 0 000 10.698v9.236a1.749 1.749 0 001.75 1.75h14.012a1.749 1.749 0 001.75-1.75v-9.236a1.749 1.749 0 00-1.75-1.75z","key":0}),React.createElement("path",{"d":"M8.755 0a2.252 2.252 0 00-1.592.659L2.195 5.627 3.32 6.752l4.639-4.639v14.794h1.592V2.114l4.639 4.639 1.125-1.125L10.347.66A2.252 2.252 0 008.755 0z","key":1})]));
}

ShareIcon.defaultProps = {"width":"17.511","height":"21.683"};

module.exports = ShareIcon;

ShareIcon.default = ShareIcon;
